module.exports = __webpack_public_path__ + "img/12_military.15c8192c.png";